import { Record, Map } from 'immutable'

const OrganizationResourcesUsageRecord = Record(
  {
    notes: Map(),
    storage: Map(),
  },
  'OrganizationResourcesUsage'
)

export default OrganizationResourcesUsageRecord
